import { Body, PrimaryLinkStyle, Small } from 'components/styled/typography'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import React, { useEffect } from 'react'
import DOMPurify from 'dompurify'

const StyledWrapper = styled.div`
  a {
    ${PrimaryLinkStyle};
    color: ${({ theme }) => theme.color.primary110};
  }
  h1 {
    font-size: ${({ theme }) => theme.space.s24};
    font-weight: 700;
  }
  h2 {
    font-size: ${({ theme }) => theme.space.s20};
  }
  h3 {
    font-size: ${({ theme }) => theme.space.s16};
  }
  h4,
  h5,
  h6 {
    font-size: ${({ theme }) => theme.space.s14};
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    line-height: 1.4;
    margin: ${({ theme }) => theme.space.s20} 0
      ${({ theme }) => theme.space.s12};
  }

  p {
    margin: 0 0 ${({ theme }) => theme.space.s12};
  }

  ul,
  ol {
    padding-left: ${({ theme }) => theme.space.s40};
    margin: 0 0 ${({ theme }) => theme.space.s12};
  }

  li {
    margin-bottom: ${({ theme }) => theme.space.s4};
  }

  blockquote {
    border-left: 3px solid ${({ theme }) => theme.color.grey20};
    padding: ${({ theme }) => theme.space.s8} ${({ theme }) => theme.space.s16};
    margin: 0 0 ${({ theme }) => theme.space.s12};
    font-style: italic;
    font-size: ${({ theme }) => theme.space.s16};
    color: ${({ theme }) => theme.color.bodyText};
    font-family: ${({ theme }) => theme.font.primary};
  }

  u {
    text-decoration: underline;
  }
`

function getHtmlWithNewLinks(html) {
  const rx = /<\s*a href="http[^>]*>(.*?)<\s*\/\s*a>/g
  const links = html.match(rx) || []
  links.forEach(link => {
    const parser = new DOMParser()
    const doc = parser.parseFromString(link, 'text/html')
    const linkElement = doc.getElementsByTagName('a')[0]
    linkElement.setAttribute('target', '_blank')
    linkElement.setAttribute('rel', 'noopener noreferrer')
    html = html.replace(link, linkElement.outerHTML)
  })
  return html
}

function Html({ html, smallText = false, ...props }) {
  const [htmlWithNewLinks, setHtmlWithNewLinks] = React.useState(html)
  useEffect(() => {
    if (html) {
      const sanitizedHtml = DOMPurify.sanitize(html)
      const newHtml = getHtmlWithNewLinks(sanitizedHtml)
      setHtmlWithNewLinks(newHtml)
    }
  }, [html])
  // TODO: replace dangerouslySetInnerHTML
  return (
    <StyledWrapper>
      {smallText ? (
        <Small
          {...props}
          dangerouslySetInnerHTML={{ __html: htmlWithNewLinks }}
        />
      ) : (
        <Body
          {...props}
          dangerouslySetInnerHTML={{ __html: htmlWithNewLinks }}
        />
      )}
    </StyledWrapper>
  )
}

Html.propTypes = {
  html: PropTypes.string,
  smallText: PropTypes.bool,
}

Html.defaultProps = {
  html: undefined,
  smallText: false,
}
export default Html
